import jQuery from 'jquery';
import 'slick-carousel'

import './components/back-button'
import './components/company-history'

import './modules/_nav';
import './modules/_form-floating-labels';

import './elementor/_colleagues-carousel'
import './elementor/_colleagues-popup'
import './elementor/_references-carousel'
